<template>
  <div class="custom-info">
    <div class="relative">
      <transition-group
        class="list clearfix"
        tag="ul"
        name="flip-list"
        v-min-height
      >
        <li class="item" v-for="(item, index) in tableData" :key="item.id">
          <el-image :src="item.avatar" class="img">
            <div slot="error" class="image-slot">
              <i class="iconfont icon-tupian"></i>
            </div>
          </el-image>
          <div class="info">
            <p class="name ellipses">
              <el-tooltip
                effect="light"
                placement="bottom-start"
                :content="item.name"
              >
                <span class="goods-name"> {{ item.name }}</span>
              </el-tooltip>
            </p>
            <p class="time">{{ item.time }}</p>
            <p class="del">
              <el-button
                size="36"
                round
                v-permission:del="$route.meta.permission"
                @click="cancelfllow(item, index)"
                class="iconfont  icon-shanchu d5"
              />
            </p>
          </div>
        </li>
      </transition-group>
      <el-button
        size="220"
        class="iconfont icon-xinzeng"
        v-permission:add="$route.meta.permission"
        @click="dialogFormVisible = true"
      >
        新增客户
      </el-button>
      <Pagination
        style="bottom: 2.5rem"
        v-if="pagination.recordTotal > 1"
        :currentPage="pagination.currentPage"
        :totalPage="pagination.pageTotal"
        :totalRecord="pagination.recordTotal"
        @handleNextPage="nextPage"
        @handlePrevPage="prevPage"
        @handleJumpPage="jumpPage"
      />
      <div class="mask" v-if="dialogFormVisible">
        <el-dialog
          :visible.sync="dialogFormVisible"
          :modal-append-to-body="false"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          :modal="false"
          custom-class="dialog"
          width="31.3rem"
          :center="true"
        >
          <el-form :model="form" label-width="auto">
            <el-form-item label="">
              <el-input
                placeholder="请输入客户会员ID"
                v-model="form.vipId"
                clearable
              />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="98" @click="dialogFormVisible = false">
              取 消
            </el-button>
            <el-button class="sub-color" size="98" @click="addRelatedCustomer">
              确 定
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from 'mixins/pagination/'

export default {
  name: 'customInfo',
  mixins: [pagination],
  data() {
    this.keyMap = {
      customer_list: {
        name: 'tableData',
        add_time: 'time',
        member_id: 'id',
        member_name: 'name',
        member_avatar: 'avatar'
      }
    }
    this.type = 'pagination'
    return {
      form: {
        name: '',
        imgUrl: ''
      },
      dialogFormVisible: false,
      pagination: {},
      tableData: []
    }
  },
  created() {
    this._customerList({
      sales_id: this.$route.query.id,
      curpage: 1
    })
  },
  methods: {
    /**
     * 获取关联客户列表
     * @param params
     */
    _customerList(params) {
      this.api.customerList(params).then(res => {
        this.utils.setCommonCode(res, this)
      })
    },

    /**
     * 翻页
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      this._customerList({
        sales_id: this.$route.query.id,
        curpage: newValue,
        pageSize: size
      })
    },
    /**
     * 取消关联
     * @param item
     * @param index
     */
    cancelfllow(item, index) {
      this.$confirm('取消关联该客户？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '删除',
        showClose: false,
        cancelButtonClass: 'el-button--98',
        confirmButtonClass: 'el-button--98 sub-color',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.tableData.splice(index, 1)
          this.api
            .delCustomer({
              member_id: item.id,
              sales_id: this.$route.query.id
            })
            .then(() => {
              this.$notify({
                type: 'success',
                message: '取消关联成功~！😝'
              })
              this._customerList({
                sales_id: this.$route.query.id,
                curpage: this.pagination.currentPage || 1
              })
            })
        })
        .catch(() => {})
    },
    /**
     * 新增关联客户
     */
    addRelatedCustomer() {
      this.api
        .getVipList({
          sales_id: this.$route.query.id,
          member_id: this.form.vipId
        })
        .then(() => {
          this.$notify({
            type: 'success',
            message: '关联成功~！😝'
          })
          this._customerList({
            sales_id: this.$route.query.id,
            curpage: this.pagination.currentPage || 1
          })
          this.dialogFormVisible = false
        })
    },
    handleChange() {}
  }
}
</script>
<style lang="scss">
.custom-info {
  .list {
    margin-right: -1.3rem;
  }

  .item {
    width: calc(20% - 1.3rem);
    height: 9.8rem;
    background-color: #fff;
    margin-right: 1.3rem;
    margin-bottom: 1.3rem;
    float: left;
    padding: 2rem;
    white-space: nowrap;
    @include maxScreenWidth(1800) {
      width: calc(25% - 1.3rem);
    }
    @include maxScreenWidth(1440) {
      width: calc(33.33% - 1.3rem);
    }

    .img {
      width: 5.8rem;
      height: 5.8rem;
      background-color: #f7f7f7;
      border-radius: 50%;
      margin-right: 1rem;
      vertical-align: middle;
    }

    .info {
      width: calc(100% - 6.8rem);
      display: inline-block;
      vertical-align: middle;
    }

    .name {
      font-size: 1.3rem;
      font-weight: bold;
    }

    .time {
      color: colors('a4');
      padding: 0.4rem 0;
    }
  }

  .ad-uploader {
    width: 5.8rem;
    height: 5.8rem;
    margin: 0 auto;
    border-radius: 50%;
    background-color: #f7f7f7;

    .el-upload {
      display: block;
      height: 100%;
    }
  }

  .intro {
    text-align: center;
    padding-top: 0.6rem;
  }
}
</style>
